module.exports = __webpack_public_path__ + "img/blue_126.0886d6d5.png";